/*
 *
 * LoginPage constants
 *
 */

export const LOGIN_ACTION = 'app/LoginPage/LOGIN_ACTION';
export const SET_LOGIN_STATUS_ACTION = 'app/LoginPage/SET_LOGIN_STATUS_ACTION';
